export default __webpack_public_path__ + "static/media/File.122f6a43.svg";